import { PageHero } from "@/components/PageHero";
import { CalendlyInline } from "@/components/Calendly";
import { IMAGES } from "@/data/content";

const CALENDLY_URL =
  "https://calendly.com/femi-o-risiwellness/massage-appointment?background_color=f5f1e9";

const Booking = () => (
  <div data-testid="booking-page">
    <PageHero
      eyebrow="Book Your Treatment"
      title="Reserve your session"
      image={IMAGES.aromatherapy}
      subtitle="Choose a time that suits you below and we'll bring the treatment to your home, hotel or workplace."
    />

    <section className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20">
      <div className="rounded-3xl border border-border bg-card overflow-hidden p-2 sm:p-4">
        <CalendlyInline url={CALENDLY_URL} className="rounded-2xl overflow-hidden" />
      </div>
      <p className="text-center text-sm text-muted-foreground mt-6">
        Prefer to talk first? <a href="/contact" className="text-primary font-semibold hover:underline">Contact us</a> and we'll help you choose the perfect treatment.
      </p>
    </section>
  </div>
);

export default Booking;
